import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import {
    ICheckFlagNameExists, IResponesType, ISystemFlagByTagResponsesType, ISystemFlagInfo, ISystemFlagRequestType,
    ISystemFlagResponsesType, ISystemFlagTagType, IUpdateStatusType, IsystemFlagDeleteRequest
} from "../types"
import { handlingErrorResponse } from "utils/HandlingErrorResponse"
import { baseUrl } from "constant";
import { RootState } from "store/store"
import { SystemFlagEndpointConst, checkFlagNameExists, getSystemFlagByTags, updateSystemFlagStatus } from "./const";
import { getAuthToken } from "utils/getAuthToken";

export const systemFlagApi = createApi({
    reducerPath: 'systemFlagApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['SystemFlag'],
    endpoints: (builder) => ({
        GetSystemFlags: builder.mutation<ISystemFlagResponsesType, ISystemFlagRequestType>({
            query: systemFlag => ({
                url: SystemFlagEndpointConst.getSystemFlags,
                method: 'POST',
                body: systemFlag
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'SystemFlag', id: 'Flag' }]
        }),
        AddEditSystemFlag: builder.mutation<IResponesType, ISystemFlagInfo>({
            query: systemFlag => ({
                url: SystemFlagEndpointConst.addEditSystemFlagUrl,
                method: 'POST',
                body: systemFlag.systemFlagObj
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'SystemFlag', id: 'Flag' }]
        }),
        UpdateSystemFlagStatus: builder.mutation<void, IUpdateStatusType>({
            query: (params) => ({
                url: updateSystemFlagStatus(params),
                method: 'PUT',
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'SystemFlag', id: 'Flag' }]
        }),
        DeleteSystemFlag: builder.mutation<void, IsystemFlagDeleteRequest>({
            query: (id) => ({
                url: SystemFlagEndpointConst.deleteSystemFlagUrl,
                method: 'DELETE',
                body: id.systemFlagId
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'SystemFlag', id: 'Flag' }]
        }),
        CheckFlagNameExists: builder.query<IResponesType, ICheckFlagNameExists>({
            query: (flagParam) => checkFlagNameExists(flagParam),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'SystemFlag', id: 'CheckFlagNameExists' }]
        }),
        GetSystemFlagByTag: builder.query<ISystemFlagByTagResponsesType, ISystemFlagTagType>({
            query: (tag) => ({
                url:getSystemFlagByTags(tag),
                method:'GET'
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'SystemFlag', id: 'GetSystemFlagByTag' }]
        })
    }),
})
